// custom
import {
    GET_ONE,
} from 'store/actions/fetchActions';

export const CRUD_GET_ONE = 'CRUD_GET_ONE';
export const CRUD_GET_ONE_SUCCESS = 'CRUD_GET_ONE_SUCCESS';

/**
 * Action 정의
 * type : 작업의 종류 (성공 혹은 실패 시 type값_SUCCESS, type값_FAILURE 액션이 발생)
 * payload : http 통신할 때 사용할 파라미터값
 * meta
 *  - menu : 호출한 메뉴의 정보 (ex. DOCUMENT.ANALYSIS)
 *  - fetch : fetch구분값 (ex. GET_LIST / GET_ONE)
 *      => 호출할 URI의 정보는 menu값_fetch값으로 구함
 *  - fetchMethod : http 통신에서 사용할 method ( default : 'get' )
 *  - popup : 성공 또는 실패 시 action이 Dialog창에 적용될 것인지 메인창에 적용될 것인지 설정 ( default : false )
 *  - onSuccess: 성공할 경우의 동작 정의 
 *      - notification : 알림 메세지
 *          - requestMsgArgs : 메세지를 만들때 필요한 값을 같이 전달하기 위한 목적
 *      - unselectAll : 체크박스 해제 
 *      - refresh : 새로고침 
 *          => notification/unselectAll/refresh 모두 popup값을 가질 수 있으며 popup값이 정의되어 있지 않은 경우 meta.popup값 적용
 *  - onFailure: 실패할 경우의 동작 정의 
 *      => onSuccess와 구조 동일
 */

/**
 * id값을 uri로 포함하여 get으로  요청하는 action
 * @param {string} menu : DOCUMENT.ANALYSIS
 * @param {Object} params : request요청 시 보낼 파라미터 
 */
export const crudGetOneById = (menu, id, params) => ({
    type: CRUD_GET_ONE,
    payload: { params },
    meta: {
        menu: menu.toUpperCase(),
        fetch: GET_ONE,
        fetchMethod: 'get',
        popup: false,
        id: id,
        onFailure: {
            notification: {
                body: "요청하신 작업이 실패하였습니다.",
                level: 'warning',
            },
        },
    },
});


export const crudGetOneByMultipart = (menu, params) => ({
  type: CRUD_GET_ONE,
  payload: { params },
  meta: { 
      menu: menu.toUpperCase(),
      fetch: GET_ONE,
      fetchMethod: 'post',
      multipart:true,
      popup: false,
      onSuccess: {
          notification: {
              body: "정상적으로 처리되었습니다.",
              level: 'info',
          }
      },
      onFailure: {
          notification: {
              body: "요청하신 작업이 실패하였습니다.",
              level: 'warning',
          },
      },
  }
});